// Smooths mouse-wheel scrolling so small-increment wheels don't produce a
// harsh ratchet feel (mainly for clean screen recordings).
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EASE = 0.12; // lower = smoother/slower catch-up
  var current = window.scrollY;
  var target = window.scrollY;
  var rafId = null;

  function clampTarget(value) {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    return Math.max(0, Math.min(value, max));
  }

  function step() {
    var diff = target - current;
    if (Math.abs(diff) < 0.5) {
      current = target;
      window.scrollTo(0, current);
      rafId = null;
      return;
    }
    current += diff * EASE;
    window.scrollTo(0, current);
    rafId = requestAnimationFrame(step);
  }

  window.addEventListener(
    'wheel',
    function (e) {
      // Let modifier-key zoom/horizontal scroll and scrollable inner
      // elements (menus, modals, sliders) behave natively.
      if (e.ctrlKey || e.metaKey) return;
      if (e.target.closest('[data-native-scroll], .disclosure__list, .drawer, dialog, .scrollable')) return;

      e.preventDefault();
      current = window.scrollY;
      target = clampTarget(target === current ? current + e.deltaY : target + e.deltaY);

      if (!rafId) rafId = requestAnimationFrame(step);
    },
    { passive: false }
  );

  window.addEventListener('resize', function () {
    target = clampTarget(target);
  });
})();
